import PubNub from "pubnub";

function getPubNubClient() {
  const environment = process.env.NEXT_PUBLIC_GOVLAUNCH_ENV || process.env.NODE_ENV || "development";

  if (environment === "test") {
    return new PubNub({
      subscribeKey: "",
      ssl: true,
      uuid: "66e46024-44b1-4733-965c-1cca9b3d8ea3",
    });
  }

  return new PubNub({
    subscribeKey: process.env.NEXT_PUBLIC_PUBNUB_SUBSCRIBE_KEY || "",
    ssl: true,
    uuid: process.env.NEXT_PUBLIC_PUBNUB_UUID || "",
  });
}

export default getPubNubClient();
